// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_mp-0";